///
/// EarthBrowser
///
/// Created by Matt Giger on 11/3/2026
/// Copyright (c) 2026 Geodata Labs
///

import { RadarTextureFrame } from "@/earthbrowser/dataset-distribution/mrms/RadarTextureFrame"
import { type CloudForecastFrameRecord } from "@/earthbrowser/dataset-distribution/cloud-forecast/CloudForecastTable"
import { type time, type timedelta } from "@stovokor/math/time"
import { vec4 } from "@stovokor/math/vector"
import { type StovokorContext } from "@stovokor/StovokorContext"

/**
 * One hour of RRFS simulated band-13 cloud: a square single-channel
 * cold-index texture (the cloud overlay's encoding) covering the lat/lon
 * box inscribed in the model's CONUS grid. Drawn through the cloud
 * shader's detail-region path like a storm cutout, so it carries the box
 * and its pixels per side; mipmapped since it is minified from orbit.
 */
export class CloudForecastTextureFrame extends RadarTextureFrame {
	/** Box in global equirectangular UV: minU, minV, maxU, maxV */
	public readonly bounds: vec4
	/** Pixels per side */
	public readonly size: number

	constructor(context: StovokorContext, record: CloudForecastFrameRecord, bounds: number[], startTime: time, duration: timedelta) {
		super(context, record.image_url, startTime, duration, false)
		this.mipmaps = true
		this.size = record.width
		const [west, south, east, north] = bounds
		this.bounds = new vec4((west + 180) / 360, (90 - north) / 180, (east + 180) / 360, (90 - south) / 180)
	}
}
